import Cookies from "js-cookie";

(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelector('.sitenews')) {
            return
        }

        if (Cookies.get('sitenews--hidden')) {
            return
        }

        document.querySelector('.sitenews').classList.remove('d-none')

        document.querySelector('.sitenews .message-box-forms .close').addEventListener('click', () => {
            document.querySelector('.sitenews').remove()
            Cookies.set('sitenews--hidden', '1', {expires: 1})
        })
    })
}) ()